<div>
    <div>
        <div class="flex-container">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{ 'common.labels.phone' | transloco }}</mat-label>
                <input matInput name="middle-name" [(ngModel)]="this.contactDetails.phoneNumber" 
                    [disabled]="!enabled" [placeholder]="'common.labels.phone' | transloco">
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{ 'common.labels.fax' | transloco }}</mat-label>
                <input matInput name="last-name" [(ngModel)]="this.contactDetails.faxNumber" 
                    [disabled]="!enabled" [placeholder]="'common.labels.fax' | transloco">
            </mat-form-field>
        </div>

        <div class="flex-container">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{ (emailLabel === '*Email' ? '*' : '') + ('common.labels.email' | transloco) }}</mat-label>
                <input matInput name="first-name" [(ngModel)]="this.contactDetails.email" 
                    [disabled]="!enabled" [placeholder]="(emailLabel === '*Email' ? '*' : '') + ('common.labels.email' | transloco)">
            </mat-form-field>   
        </div>
    </div>

    <div>
        <h3>{{ 'common.labels.address' | transloco }}</h3>
        <div class="flex-container">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{ 'common.labels.streetNumber' | transloco }}</mat-label>
                <input matInput name="street-number" [(ngModel)]="this.contactDetails.address.streetNumber"
                    [disabled]="!enabled" [placeholder]="'common.labels.streetNumber' | transloco">
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{ 'common.labels.streetName' | transloco }}</mat-label>
                <input matInput name="street-name" [(ngModel)]="this.contactDetails.address.streetName" 
                    [disabled]="!enabled" [placeholder]="'common.labels.streetName' | transloco">
            </mat-form-field>
        </div>
        
        <div class="flex-container">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{ 'common.labels.unit' | transloco }}</mat-label>
                <input matInput name="street-unit" [(ngModel)]="this.contactDetails.address.unit" 
                    [disabled]="!enabled" [placeholder]="'common.labels.unit' | transloco">
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{ 'common.labels.city' | transloco }}</mat-label>
                <input matInput name="city" [(ngModel)]="this.contactDetails.address.city" 
                    [disabled]="!enabled" [placeholder]="'common.labels.city' | transloco">
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{ 'common.labels.postalCode' | transloco }}</mat-label>
                <input matInput name="postal-code" [(ngModel)]="this.contactDetails.address.postalCode" 
                    [disabled]="!enabled" [placeholder]="'common.labels.postalCode' | transloco">
            </mat-form-field>
        </div>

        <div class="flex-container-no-padding">
            
            <lib-jurisdiction-selection [appearance]="appearance" 
            [enabled]="enabled"
            [countryFieldName]="'CountryCode'" [jurisdictionFieldName]="'Jurisdiction'"
            [defaultCountry]="this.contactDetails.address.countryCode ?? 'CA'"
            [defaultJurisdiction]="this.contactDetails.address.jurisdiction ?? ''"
            (jurisdictionChosenEvent)="handleJurisdictionChangeEvent($event)"
            (countryChosenEvent)="handleCountryChangeEvent($event)"
            ></lib-jurisdiction-selection>
        </div>
    </div>
</div>